export default __webpack_public_path__ + "static/media/IMG_1003.16d9fa32.jpeg";